import { useDispatch, useSelector } from 'react-redux';

import PaymentMethod, { IMethodData } from '@r1-frontend/ui-react/organisms/Payment/PaymentMethod';

import { addNewPayMethods } from '~/src/features/payments-abn/store/actions';
import { TState } from '~/src/store';

const sbpMethod: IMethodData = {
    id: 'sbp',
    methodType: 'sbp',
    label: 'СБП',
    value: 'sbp',
    imagePath: '/static/images/payments-abn/sbp.png',
    imageAlt: 'Логотип СБП',
    isAutoPayConnected: true,
};

export const useSbpPayment = (): void => {
    const dispatch = useDispatch();
    const hasSbp = useSelector((state: TState) => state.city.currentCity.has_QPS);

    if (!hasSbp) {
        return;
    }

    sbpMethod.widget = PaymentMethod;

    dispatch(addNewPayMethods([sbpMethod]));
};
